<template>
	<a-tabs default-active-key="a" @change="callback">
		<a-tab-pane key="a" tab="应收分析">
			<div class="content_main o_s" style="padding: 5px; box-sizing: border-box">
				<div class="chart_box">
					<div class="chart" id="chart1"></div>
				</div>
				<div class="chart_main">
					<div class="main_l">
						<div class="serch_box">
							<a-select class="a_select_self margin_self" allowClear size="small" placeholder="请选择">
								<a-select-option :value="item.value" v-for="(item, index) in years" :key="index">
									{{ item.label }}
								</a-select-option>
							</a-select>
						</div>
						<div class="chart_center" id="chart2"></div>
					</div>
					<div class="main_r">
						<div class="serch_box">
							<a-select class="a_select_self margin_self" allowClear size="small" placeholder="请选择">
								<a-select-option :value="item.value" v-for="(item, index) in years" :key="index">
									{{ item.label }}
								</a-select-option>
							</a-select>
						</div>
						<div class="chart_center" id="chart3"></div>
					</div>
				</div>
			</div>
		</a-tab-pane>
		<a-tab-pane key="b" tab="应付分析">
			<div class="content_main o_s" style="padding: 5px; box-sizing: border-box">
				<div class="chart_box2">
					<div class="serch_box">
						<a-select class="a_select_self margin_self" allowClear size="small" placeholder="请选择">
							<a-select-option :value="item.value" v-for="(item, index) in years" :key="index">
								{{ item.label }}
							</a-select-option>
						</a-select>
					</div>
					<div class="chart" id="chart4"></div>
					<div class="chart2" id="chart5"></div>
				</div>
				<div class="chart_box2">
					<div class="serch_box">
						<a-select class="a_select_self margin_self" allowClear size="small" placeholder="请选择">
							<a-select-option :value="item.value" v-for="(item, index) in years" :key="index">
								{{ item.label }}
							</a-select-option>
						</a-select>
					</div>
					<div class="chart" id="chart6"></div>
					<div class="chart2" id="chart7"></div>
				</div>
				<div class="chart_box2">
					<div class="serch_box">
						<a-select class="a_select_self margin_self" allowClear size="small" placeholder="请选择">
							<a-select-option :value="item.value" v-for="(item, index) in years" :key="index">
								{{ item.label }}
							</a-select-option>
						</a-select>
					</div>
					<div class="chart3" id="chart8"></div>
				</div>
				<div class="chart_box2">
					<div class="serch_box">
						<a-select class="a_select_self margin_self" allowClear size="small" placeholder="请选择">
							<a-select-option :value="item.value" v-for="(item, index) in years" :key="index">
								{{ item.label }}
							</a-select-option>
						</a-select>
					</div>
					<div class="chart3" id="chart9"></div>
				</div>
			</div>
		</a-tab-pane>
	</a-tabs>
</template>

<script>
	export default {
		data() {
			return {
				years: [],
				xAxis: ['差旅费', '招待费', '设备采购', '耗材采购', '办公用品', '活动经费', '房租水电', '其他费用'],
				monthxAxis: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
				tabs: {
					a: true,
					b: false,
				},
			}
		},
		mounted() {
			var first_year = 2009
			var last_year = new Date().getFullYear()

			for (var i = first_year; i <= last_year; i++) {
				this.years.push({
					value: i,
					label: i + '年',
				})
			}
			this.set_chart1()
			this.set_chart2()
			this.set_chart3()
		},
		methods: {
			callback(key) {
				if (!this.tabs[key]) {
					this.tabs[key] = true
					this.$nextTick(() => {
						switch (key) {
							case 'b':
								this.set_chart4()
								this.set_chart5()
								this.set_chart6()
								this.set_chart7()
								this.set_chart8()
								this.set_chart9()
								break
						}
					})
				}
			},
			set_chart1() {
				var dom = document.getElementById('chart1')
				var myChartNowMonth = this.$echarts.init(dom)
				var option = {
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'shadow',
						},
					},
					title: {
						text: '各公司应收总额',
					},
					legend: {
						data: ['应收总额', '已收金额', '应收余额(未回款)']
					},
					grid: {
						left: '1%',
						right: '1%',
						bottom: '3%',
						top: '70',
						containLabel: true,
					},
					toolbox: {
						show: true,
						left: 0,
						top: 25,
						feature: {
							mark: {
								show: true
							},
							dataView: {
								show: true,
								readOnly: false
							},
							magicType: {
								show: true,
								type: ['line', 'bar']
							},
							restore: {
								show: true
							},
							saveAsImage: {
								show: true
							},
						},
					},
					xAxis: {
						type: 'category',
						data: this.monthxAxis
					},
					yAxis: [{
						type: 'value',
						axisLabel: {
							formatter: '{value}'
						}
					}, ],
					series: [{
							name: '应收总额',
							type: 'bar',
							barWidth: 20, //柱图宽度
							data: [620, 732, 701, 734, 1090, 1130, 1120, 765, 734, 345, 564, 367],
							itemStyle: {
								normal: {
									color: '#73a0fa'
								}
							}
						},
						{
							name: '已收金额',
							type: 'bar',
							barWidth: 20, //柱图宽度
							data: [120, 132, 101, 134, 290, 230, 220, 345, 111, 231, 563, 643],
							itemStyle: {
								normal: {
									color: '#73deb3'
								}
							}
						},
						{
							name: '应收余额(未回款)',
							type: 'bar',
							barWidth: 20, //柱图宽度
							data: [135, 122, 101, 334, 590, 130, 290, 325, 111, 131, 863, 243],
							itemStyle: {
								normal: {
									color: 'rgb(115,131,160)'
								}
							}
						}
					]
				}
				option && myChartNowMonth.setOption(option)
			},
			set_chart2() {
				var dom = document.getElementById('chart2')
				var myChartNowMonth = this.$echarts.init(dom)
				var option = {
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'shadow',
						},
					},
					title: {
						text: '账龄分析',
					},
					legend: {},
					grid: {
						left: '1%',
						right: '1%',
						bottom: '3%',
						top: '70',
						containLabel: true,
					},
					toolbox: {
						show: true,
						left: 0,
						top: 25,
						feature: {
							mark: {
								show: true
							},
							dataView: {
								show: true,
								readOnly: false
							},
							magicType: {
								show: true,
								type: ['line', 'bar']
							},
							restore: {
								show: true
							},
							saveAsImage: {
								show: true
							},
						},
					},
					xAxis: [{
						type: 'category',
						data: this.monthxAxis,
					}, ],
					yAxis: [{
						type: 'value',
					}, ],
					series: [{
						type: 'bar',
						barWidth: 24,
						data: [
							120,
							150,
							80,
							70,
							110,
							130,
							{
								value: 200,
								itemStyle: {
									color: 'rgb(235,126,101)'
								}
							},
							{
								value: 100,
								itemStyle: {
									color: 'rgb(235,126,101)'
								}
							},
						],
						itemStyle: {
							normal: {
								color: 'rgb(115,160,250)'
							}
						}
					}, ],
				}
				option && myChartNowMonth.setOption(option)
			},
			set_chart3() {
				var dom = document.getElementById('chart3')
				var myChartNowMonth = this.$echarts.init(dom)
				var option = {
					title: {
						text: '不同账龄占比',
					},
					tooltip: {
						trigger: 'item',
					},
					legend: {
						top: '10%',
						left: 'left',
						orient: 'vertical',
					},
					series: [{
						name: 'Access From',
						type: 'pie',
						radius: '50%',
						itemStyle: {
							normal: {
								label: {
									show: true,
									formatter: '{d}%',
								},
								labelLine: {
									show: true,
								},
							},
						},
						avoidLabelOverlap: false,
						label: {
							show: false,
							position: 'center',
						},
						emphasis: {
							label: {
								show: true,
								fontSize: '20',
								fontWeight: 'bold',
							},
						},
						labelLine: {
							show: false,
						},
						data: [{
								value: 1048,
								name: 'Search Engine'
							},
							{
								value: 735,
								name: 'Direct'
							},
							{
								value: 580,
								name: 'Email'
							},
							{
								value: 484,
								name: 'Union Ads'
							},
							{
								value: 300,
								name: 'Video Ads'
							},
						],
					}, ],
				}
				option && myChartNowMonth.setOption(option)
			},
			set_chart4() {
				var dom = document.getElementById('chart4')
				var myChartNowMonth = this.$echarts.init(dom)
				var option = {
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'shadow',
						},
					},
					title: {
						text: '报销费用',
					},
					legend: {},
					grid: {
						left: '1%',
						right: '1%',
						bottom: '3%',
						top: '70',
						containLabel: true,
					},
					toolbox: {
						show: true,
						left: 0,
						top: 25,
						feature: {
							mark: {
								show: true
							},
							dataView: {
								show: true,
								readOnly: false
							},
							magicType: {
								show: true,
								type: ['line', 'bar']
							},
							restore: {
								show: true
							},
							saveAsImage: {
								show: true
							},
						},
					},
					xAxis: [{
						type: 'category',
						data: this.xAxis,
					}, ],
					yAxis: [{
						type: 'value',
					}, ],
					series: [{
						type: 'bar',
						barWidth: 8,
						data: [{
								value: 200,
								itemStyle: {
									color: 'rgb(117,161,248)'
								}
							},
							{
								value: 100,
								itemStyle: {
									color: 'rgb(115,220,177)'
								}
							},
							{
								value: 120,
								itemStyle: {
									color: 'rgb(125,134,165)'
								}
							},
							{
								value: 150,
								itemStyle: {
									color: 'rgb(248,201,59)'
								}
							},
							{
								value: 80,
								itemStyle: {
									color: 'rgb(233,124,103)'
								}
							},
							{
								value: 70,
								itemStyle: {
									color: 'rgb(137,212,243)'
								}
							},
							{
								value: 110,
								itemStyle: {
									color: 'rgb(159,133,207)'
								}
							},
							{
								value: 130,
								itemStyle: {
									color: 'rgb(255,171,101)'
								}
							},
						],
					}, ],
				}
				option && myChartNowMonth.setOption(option)
			},
			set_chart5() {
				var dom = document.getElementById('chart5')
				var myChartNowMonth = this.$echarts.init(dom)
				var option = {
					title: {
						text: '',
					},
					tooltip: {
						trigger: 'item',
					},
					legend: {
						top: '10%',
						left: 'left',
						orient: 'vertical',
					},
					series: [{
						name: 'Access From',
						type: 'pie',
						radius: '50%',
						itemStyle: {
							normal: {
								label: {
									show: true,
									formatter: '{d}%',
								},
								labelLine: {
									show: true,
								},
							},
						},
						avoidLabelOverlap: false,
						label: {
							show: false,
							position: 'center',
						},
						emphasis: {
							label: {
								show: true,
								fontSize: '20',
								fontWeight: 'bold',
							},
						},
						labelLine: {
							show: false,
						},
						data: [{
								value: 1048,
								name: 'Search Engine'
							},
							{
								value: 735,
								name: 'Direct'
							},
							{
								value: 580,
								name: 'Email'
							},
							{
								value: 484,
								name: 'Union Ads'
							},
							{
								value: 300,
								name: 'Video Ads'
							},
						],
					}, ],
				}
				option && myChartNowMonth.setOption(option)
			},
			set_chart6() {
				var dom = document.getElementById('chart6')
				var myChartNowMonth = this.$echarts.init(dom)
				var option = {
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'shadow',
						},
					},
					title: {
						text: '付款费用',
					},
					legend: {},
					grid: {
						left: '1%',
						right: '1%',
						bottom: '3%',
						top: '70',
						containLabel: true,
					},
					toolbox: {
						show: true,
						left: 0,
						top: 25,
						feature: {
							mark: {
								show: true
							},
							dataView: {
								show: true,
								readOnly: false
							},
							magicType: {
								show: true,
								type: ['line', 'bar']
							},
							restore: {
								show: true
							},
							saveAsImage: {
								show: true
							},
						},
					},
					xAxis: [{
						type: 'category',
						data: this.xAxis,
					}, ],
					yAxis: [{
						type: 'value',
					}, ],
					series: [{
						type: 'bar',
						barWidth: 8,
						data: [{
								value: 200,
								itemStyle: {
									color: 'rgb(117,161,248)'
								}
							},
							{
								value: 100,
								itemStyle: {
									color: 'rgb(115,220,177)'
								}
							},
							{
								value: 120,
								itemStyle: {
									color: 'rgb(125,134,165)'
								}
							},
							{
								value: 150,
								itemStyle: {
									color: 'rgb(248,201,59)'
								}
							},
							{
								value: 80,
								itemStyle: {
									color: 'rgb(233,124,103)'
								}
							},
							{
								value: 70,
								itemStyle: {
									color: 'rgb(137,212,243)'
								}
							},
							{
								value: 110,
								itemStyle: {
									color: 'rgb(159,133,207)'
								}
							},
							{
								value: 130,
								itemStyle: {
									color: 'rgb(255,171,101)'
								}
							},
						],
					}, ],
				}
				option && myChartNowMonth.setOption(option)
			},
			set_chart7() {
				var dom = document.getElementById('chart7')
				var myChartNowMonth = this.$echarts.init(dom)
				var option = {
					title: {
						text: '',
					},
					tooltip: {
						trigger: 'item',
					},
					legend: {
						top: '10%',
						left: 'left',
						orient: 'vertical',
					},
					series: [{
						name: 'Access From',
						type: 'pie',
						radius: '50%',
						itemStyle: {
							normal: {
								label: {
									show: true,
									formatter: '{d}%',
								},
								labelLine: {
									show: true,
								},
							},
						},
						avoidLabelOverlap: false,
						label: {
							show: false,
							position: 'center',
						},
						emphasis: {
							label: {
								show: true,
								fontSize: '20',
								fontWeight: 'bold',
							},
						},
						labelLine: {
							show: false,
						},
						data: [{
								value: 1048,
								name: 'Search Engine'
							},
							{
								value: 735,
								name: 'Direct'
							},
							{
								value: 580,
								name: 'Email'
							},
							{
								value: 484,
								name: 'Union Ads'
							},
							{
								value: 300,
								name: 'Video Ads'
							},
						],
					}, ],
				}
				option && myChartNowMonth.setOption(option)
			},
			set_chart8() {
				var dom = document.getElementById('chart8')
				var myChartNowMonth = this.$echarts.init(dom)
				var option = {
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'shadow',
						},
					},
					title: {
						text: '各公司应收总额',
					},
					legend: {
						data: ['应收总额', '已收金额', '应收余额(未回款)']
					},
					grid: {
						left: '1%',
						right: '1%',
						bottom: '3%',
						top: '70',
						containLabel: true,
					},
					toolbox: {
						show: true,
						left: 0,
						top: 25,
						feature: {
							mark: {
								show: true
							},
							dataView: {
								show: true,
								readOnly: false
							},
							magicType: {
								show: true,
								type: ['line', 'bar']
							},
							restore: {
								show: true
							},
							saveAsImage: {
								show: true
							},
						},
					},
					xAxis: {
						type: 'category',
						data: this.xAxis
					},
					yAxis: [{
						type: 'value',
						axisLabel: {
							formatter: '{value}'
						}
					}, ],
					series: [{
							name: '应收总额',
							type: 'bar',
							barWidth: 8, //柱图宽度
							data: [620, 732, 701, 734, 1090, 1130, 1120, 765, 734, 345, 564, 367],
							itemStyle: {
								normal: {
									color: '#73a0fa'
								}
							}
						},
						{
							name: '已收金额',
							type: 'bar',
							barWidth: 8, //柱图宽度
							data: [120, 132, 101, 134, 290, 230, 220, 345, 111, 231, 563, 643],
							itemStyle: {
								normal: {
									color: '#73deb3'
								}
							}
						},
						{
							name: '应收余额(未回款)',
							type: 'bar',
							barWidth: 8, //柱图宽度
							data: [135, 122, 101, 334, 590, 130, 290, 325, 111, 131, 863, 243],
							itemStyle: {
								normal: {
									color: 'rgb(115,131,160)'
								}
							}
						}
					]
				}
				option && myChartNowMonth.setOption(option)
			},
			set_chart9() {
				var dom = document.getElementById('chart9')
				var myChartNowMonth = this.$echarts.init(dom)
				var option = {
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							// Use axis to trigger tooltip
							type: 'shadow' // 'shadow' as default; can also be 'line' or 'shadow'
						}
					},
					title: {
						text: '各公司总览',
					},
					legend: {},
					grid: {
						left: '3%',
						right: '4%',
						bottom: '3%',
						containLabel: true
					},
					xAxis: {
						type: 'value'
					},
					yAxis: {
						type: 'category',
						data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
					},
					series: [{
							name: 'Direct',
							type: 'bar',
							stack: 'total',
							label: {
								show: true
							},
							emphasis: {
								focus: 'series'
							},
							data: [320, 302, 301, 334, 390, 330, 320]
						},
						{
							name: 'Mail Ad',
							type: 'bar',
							stack: 'total',
							label: {
								show: true
							},
							emphasis: {
								focus: 'series'
							},
							data: [120, 132, 101, 134, 90, 230, 210]
						},
						{
							name: 'Affiliate Ad',
							type: 'bar',
							stack: 'total',
							label: {
								show: true
							},
							emphasis: {
								focus: 'series'
							},
							data: [220, 182, 191, 234, 290, 330, 310]
						},
						{
							name: 'Video Ad',
							type: 'bar',
							stack: 'total',
							label: {
								show: true
							},
							emphasis: {
								focus: 'series'
							},
							data: [150, 212, 201, 154, 190, 330, 410]
						},
						{
							name: 'Search Engine',
							type: 'bar',
							stack: 'total',
							label: {
								show: true
							},
							emphasis: {
								focus: 'series'
							},
							data: [820, 832, 901, 934, 1290, 1330, 1320]
						}
					]
				}
				option && myChartNowMonth.setOption(option)
			},
		},
	}
</script>

<style scoped lang='less'>
	.chart_box {
		width: 100%;
		height: 400px;
		float: left;
		padding: 10px;
		box-sizing: border-box;
		box-shadow: 0 0 5px 1px #e2e2e2;
		border-radius: 5px;

		.chart {
			width: 100%;
			height: 100%;
			float: left;
		}

	}

	.chart_main {
		width: 100%;
		height: 375px;
		float: left;
		position: relative;
		margin-top: 15px;

		.main_l {
			width: calc(62% - 10px);
			margin-right: 10px;
			height: 100%;
			float: left;
			padding: 10px;
			box-sizing: border-box;
			box-shadow: 0 0 5px 1px #e2e2e2;
			border-radius: 5px;

			.chart_center {
				width: 100%;
				height: 100%;
				float: left;
			}

			.serch_box {
				position: absolute;
				right: 0;
				top: 10px;
				z-index: 999;
			}
		}

		.main_r {
			width: 38%;
			height: 100%;
			float: left;
			padding: 10px;
			box-sizing: border-box;
			box-shadow: 0 0 5px 1px #e2e2e2;
			border-radius: 5px;

			.chart_center {
				width: 100%;
				height: 100%;
				float: left;
			}

			.serch_box {
				position: absolute;
				right: calc(38% + 10px);
				top: 10px;
				z-index: 999;
			}
		}
	}

	.chart_box2 {
		width: 100%;
		height: 400px;
		float: left;
		position: relative;
		padding: 10px;
		margin-top: 15px;
		box-sizing: border-box;
		box-shadow: 0 0 5px 1px #e2e2e2;
		border-radius: 5px;

		.chart {
			width: calc(62% - 10px);
			height: 100%;
			float: left;
		}

		.chart2 {
			width: 38%;
			height: 100%;
			float: left;
		}

		.chart3 {
			width: 100%;
			height: 100%;
			float: left;
		}

		.serch_box {
			position: absolute;
			right: 0;
			top: 10px;
			z-index: 999;
		}
	}
</style>
